<template>
  <v-dialog
    :model-value="showModal"
    scrollable
    persistent
    :fullscreen="$vuetify.display.xs"
    max-width="800px"
  >
    <v-card class="pb-4">
      <v-card-title class="justify-center">
        <h3 role="heading" aria-level="2" class="card-title pt-1 font-weight-regular">
          {{ $t('L_child_rider_exchange_package') }}
        </h3>
      </v-card-title>
      <v-spacer class="pt-2" />
      <v-card-text class="text-content mb-4">
        <v-card class="overflow-y-auto">
          <v-card-text
            id="scroll-target"
            v-scroll:#scroll-target="onScroll"
            column
            align-center
            justify-center
            style="max-height: 400px"
          />
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-row justify="center">
          <v-col cols="8" md6>
            <OnexButton id="btn_close" block color="primary" @click="close">
              {{ $t('L_close') }}
            </OnexButton>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'ChildRiderExchangePackage',
  components: {
    OnexButton,
  },
  data() {
    return {
      offsetTop: 0,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onScroll(e: Event) {
      const target = e.target as HTMLElement;
      this.offsetTop = target.scrollTop;
    },
  },
};

export default defineComponent(componentOptions);
</script>
